import profileImg from '../../static/images/profile.png';
import transactionview from '../../static/images/transactionview.png';
import onboardingImg from '../../static/images/sidebarIcon/onboardingImg.png';
import refundImg from '../../static/images/sidebarIcon/refundImg.png';
import accessManagement from '../../static/images/sidebarIcon/accessManagement.png';
import dashBoard from '../../static/images/sidebarIcon/dashBoard.png';
import manageAccount from '../../static/images/sidebarIcon/manageAccount.png';
import manageBin from '../../static/images/sidebarIcon/manageBin.png';
import myAccount from '../../static/images/sidebarIcon/myAccount.png';
import paymentPage from "../../static/images/wallet.png"

export const MENU_LIST = [
    {
        menuName: 'Access Management',
        serverKey: 'access_management',
        imgSrc: accessManagement,
        subMenu: [
            {
                menuName: 'Role Management',
                serverKey: 'role_management',
                link: '/rolemanagement',
            },
            {
                menuName: 'User Management',
                serverKey: 'user_management',
                link: '/usermanagement',
            },
            {
                menuName: 'Role Verification',
                serverKey: 'role_verification',
                link: '/roleverification',
            },
            {
                menuName: 'User Verification',
                serverKey: 'user_verification',
                link: '/userverification',
            },
        ],
    },
    {
        menuName: 'Onboarding',
        serverKey: 'merchant_onboarding,edit_merchant_onboarding',
        imgSrc: onboardingImg,
        // isParentLevelPermission: true,
        subMenu: [
            {
                menuName: 'TID Onboarding',
                serverKey: 'view_tid, edit_tid, create_merchant,create_merchant_button',
                link: '/tid-onboarding',
            },
            {
                menuName: 'MID Onboarding',
                serverKey: 'view_merchant, edit_merchant,create_merchant,create_merchant_button',
                link: '/mob',
            },
            {
                menuName: 'MLE Onboarding',
                serverKey: 'update_mle,create_mle_button,fetch_mle,create_merchant,create_merchant_button,create mle',
                link: '/mle-onboarding',
            },
            {
                menuName: 'Merchant Maker',
                serverKey: 'view_merchant_maker,maker',
                link: '/maker',
            },
            {
                menuName: 'Requested Approvals',
                serverKey: 'requested_approvals,checker',
                link: '/checker',
            },
        ],
    },
    {
        menuName: 'PG Credentials Repository',
        // TODO! change this permission in future
        serverKey: 'merchant_onboarding',
        imgSrc: transactionview,
        link: '/payment-gateway-credentials',
    },
    {
        menuName: 'Transaction View',
        serverKey: 'reports',
        imgSrc: transactionview,
        link: '/transactions',
    },
    {
        menuName: 'Mandate View',
        serverKey: 'mandates',
        imgSrc: transactionview,
        link: '/mandate',
    },
    {
        menuName: 'Merchant Adjustments',
        serverKey: 'reports',
        imgSrc: transactionview,
        link: '/merchant-adjustments',
    },
    {
        menuName: 'Refund',
        serverKey: 'refunds',
        imgSrc: refundImg,
        isParentLevelPermission: true,
        subMenu: [
            {
                menuName: 'Refund',
                serverKey: 'refunds',
                link: '/refund',
            },
            {
                menuName: 'Bulk Refund',
                serverKey: 'bulk_refund',
                link: '/bulk-refund',
            },
        ],
    },
    {
        menuName: 'Settlement',
        serverKey: 'view_settlement',
        imgSrc: refundImg,
        isParentLevelPermission: true,
        subMenu: [
            {
                menuName: 'Settlement',
                serverKey: 'settlement',
                link: '/settlement',
            },
            {
                menuName: 'Invoice',
                serverKey: 'bulk_refund',
                link: '/invoice',
            },
        ],
    },
    {
        menuName: 'Manage Bin',
        serverKey: 'manage_bin',
        imgSrc: manageBin,
        link: '/manage-bin',
    },
    {
        menuName: 'Manage Account',
        serverKey: 'manage_account',
        imgSrc: manageAccount,
        subMenu: [
            {
                menuName: 'Communication Profile',
                serverKey: 'communication_profile',
                link: '/communication',
            },
        ],
    },
    {
        menuName: 'My Account',
        serverKey: 'my_account',
        imgSrc: myAccount,
        subMenu: [
            {
                menuName: 'Profile',
                serverKey: 'merchant_profile',
                link: '/profile',
            },
            {
                menuName: 'Checkout Customization',
                serverKey: 'merchant_profile',
                link: '/checkout-customization',
            },
        ],
    },
    {
        menuName: 'Dashboard',
        serverKey: 'dashboard',
        imgSrc: dashBoard,
        link: '/dashboard',
    },
    {
        menuName: 'Payment Link',
        serverKey: 'payment_links',
        imgSrc: profileImg,
        isParentLevelPermission: true,
        subMenu: [
            {
                menuName: 'Payment Link',
                serverKey: 'manage_payment_link',
                link: '/payment-link',
            },
            {
                menuName: 'Bulk Payment Link',
                serverKey: 'manage_payment_link',
                link: '/bulk-payment-link',
            },
            {
                menuName: 'Bulk Account Verification',
                serverKey: 'manage_payment_link',
                link: '/bulk-account-verification',
            },
            
        ],
    },
    {
        menuName: 'Payment Page',
        serverKey: 'payment_links',
        imgSrc: paymentPage,
        link: '/payment-page',
    },
    {
        menuName: 'Dispute resolution',
        serverKey: 'chargeback',
        imgSrc: refundImg,
        link: '/chargeback',
    },
    {
        menuName: 'Audit Trail',
        serverKey: 'audit_trail',
        imgSrc: profileImg,
        link: '/audit-report',
    },
];
